import { IDeploymentAndValueStatsCategorySavingsAggregate } from '@kcftech/prometheus-client';
import { PieChartWithLegend } from 'pages/Dashboard/components/PieChartWithLegend';
import { useMemo } from 'react';
import { tokens } from 'styles/tokens';
import { sortBy } from 'utils/array';
import { getTrendLineColorForIndex, TrendLineColors } from 'utils/colors';

export function ValueBySavingsType({
    data,
}: {
    data: IDeploymentAndValueStatsCategorySavingsAggregate[];
}) {
    const mappedData = useMemo(
        () =>
            sortBy(data, (d) => -d.MonetaryValue).map((d, idx) => {
                const color: string = getTrendLineColorForIndex(idx);
                return {
                    name: d.Key,
                    value: d.MonetaryValue,
                    fill:
                        color === TrendLineColors.trendLine1
                            ? tokens.primary.default
                            : color,
                };
            }),
        [data],
    );

    return (
        <PieChartWithLegend
            data={mappedData}
            legendPosition="auto"
            legendVariant="simple"
            innerRadius="65%"
            outerRadius="88%"
            formatSecondaryText={(item) => {
                const percent =
                    (item.value / mappedData.reduce((sum, d) => sum + d.value, 0)) * 100;
                return `$${item.value.toLocaleString()} (${percent.toFixed(2)}%)`;
            }}
            legendIconVariant="circle"
        />
    );
}
